import React from 'react';
import Reflux from 'reflux';
import StartTimePicker from './startTimePicker.jsx';
import CuesheetCellActions from 'flux/actions/cuesheet/CuesheetCellActions';
import CuesheetCursorActions from 'flux/actions/cuesheet/CuesheetCursorActions';
import { EditableCellTypes } from 'flux/stores/cuesheet/CuesheetConstants';
import UIRegions from 'shared/constants/UIRegions';
import TimeUtil from 'time';
import StartTimeMixin from 'main/components/show/cuesheet/startTimeMixin';
import PureRenderMixin from 'react-addons-pure-render-mixin';
import RoleHelper from 'shared/lib/role';
import OverrideIcon from './overrideIcon.jsx';
import { Icon } from '@shoflo-rundown/polymer.legacy';
import classNames from 'classnames';
import PopoverActions from 'flux/actions/PopoverActions';
import PopoverStore from 'flux/stores/PopoverStore';
import readOnlyHelper from 'flux/helpers/readOnlyHelper';

/**
 * Item Start Time component
 *
 */
export default React.createClass({
  mixins: [
    StartTimeMixin,
    PureRenderMixin,
    Reflux.connectFilter(PopoverStore, 'showArrowIcons', (popovers) =>
      popovers.get(UIRegions.CuesheetStartTimeArrows),
    ),
  ],

  displayName: 'ItemStartTime',

  contextTypes: {
    router: React.PropTypes.object.isRequired,
  },

  propTypes: {
    user: React.PropTypes.object,
    item: React.PropTypes.object.isRequired,
    rowIndex: React.PropTypes.number.isRequired,
    twentyFourHourClock: React.PropTypes.bool.isRequired,
    timeZone: React.PropTypes.string.isRequired,
  },

  render() {
    const { displayStartTime, displayStartTimeClock } = this.props;

    if (!displayStartTime) return null;

    const wrapperClasses = classNames('cs-wrapper-start-time', {
      'show-on-hover': !displayStartTimeClock,
    });

    if (!this._hasAdmin()) {
      return (
        <span className={wrapperClasses}>
          {this._getDirectionalIconNode()}
          {this._getDisplayNode()}
        </span>
      );
    }

    return this._getTimePickerNode(wrapperClasses);
  },

  _getDisplayNode() {
    const { twentyFourHourClock, item } = this.props;

    const overrideFlag = item.get('startOn');

    const classes = classNames(
      'cs-start-time-cell read-only',
      { 'cs-start-time-non-admin input-time-wrapper': !this._hasAdmin() },
      { 'time-override-flag': overrideFlag },
    );

    const startTimeCell = (
      <div className={classes}>
        {TimeUtil.getShorthandTimeUTC(
          this._getStartTimeValue(),
          twentyFourHourClock,
        )}
      </div>
    );

    return startTimeCell;
  },

  _getDirectionalIconNode() {
    const { rowIndex, item, startOn, startTimeBackwardAdjusted } = this.props;
    const { showArrowIcons } = this.state;

    /**
     * Show the directional icon only for items that don't have a startOn
     */
    const hasOverride = startOn ? true : false;
    const showDirectionalIcon = showArrowIcons && !hasOverride;

    const directionalIconWidth = 15;
    const directionIconStyles = {
      position: 'relative',
      display: 'inline-block',
      width: directionalIconWidth,
    };
    /**
     * Directional icon node indicates which way durations are counted against start times
     */
    let directionalIconNode = showDirectionalIcon ? (
      <span style={directionIconStyles}>
        <Icon
          className="cs-timers-flag"
          name={startTimeBackwardAdjusted ? 'arrow-up' : 'arrow-down'}
          ours
        />
      </span>
    ) : null;

    //Add a "spacer" if the hover icon isn't present
    if (!hasOverride && !showArrowIcons) {
      directionalIconNode = <span style={directionIconStyles}></span>;
    }

    return (
      <span>
        {directionalIconNode}
        <OverrideIcon
          onClick={this._handleOverride}
          onMouseEnter={() => {
            PopoverActions.show(UIRegions.CuesheetStartTimeArrows);
            //After a time, if the directional/hover icons are showing, hide them
            clearTimeout(this._directionalIconTimeout);
            this._directionalIconTimeout = setTimeout(() => {
              if (showArrowIcons) {
                PopoverActions.hide(UIRegions.CuesheetStartTimeArrows);
              }
            }, 5000);
          }}
          onMouseLeave={() => {
            PopoverActions.hide(UIRegions.CuesheetStartTimeArrows, true);
          }}
          {...{ rowIndex, item }}
          field="startOn"
        />
      </span>
    );
  },

  _getToggleStartTimeNode() {
    const { displayStartTimeClock } = this.props;

    let iconName = displayStartTimeClock ? 'eye' : 'eye-slash';

    return <Icon name={iconName} onClick={() => this._toggleStartTime()} />;
  },

  _hasAdmin() {
    const params = this.context.router.state.params;
    const { teamId, eventId } = params;

    return RoleHelper.hasEventAdminRole(this.props.user, teamId, eventId);
  },

  _getTimePickerNode(wrapperClasses) {
    const {
      displayStartTimeClock,
      rowIndex,
      isSelected,
      twentyFourHourClock,
      simple,
      startOn,
      startOnInReverse,
    } = this.props;

    const isManualTime = startOn !== 0 ? true : false;
    const placement = simple ? 'top' : 'left';

    return (
      <div className={wrapperClasses} onClick={() => this._handleClick()}>
        {this._getDirectionalIconNode()}
        <StartTimePicker
          {...{ placement, isSelected, rowIndex }}
          idSuffix="cue-start"
          value={this._getStartTimeValue()}
          twentyFour={twentyFourHourClock}
          displayNode={this._getDisplayNode()}
          displayStartTimeClock={displayStartTimeClock}
          startOnInReverse={startOnInReverse}
          showResetButton={isManualTime}
          id={EditableCellTypes.ItemStartTime + rowIndex}
        />
        {this._getToggleStartTimeNode()}
      </div>
    );
  },

  _handleClick() {
    const { isSelected, rowIndex } = this.props;

    if (readOnlyHelper.alertPastEventNotEditable()) {
      return;
    }

    if (isSelected) {
      const popoverId = EditableCellTypes.ItemStartTime + rowIndex;
      PopoverActions.show(popoverId);
    } else {
      this._select();
    }
  },

  _toggleStartTime() {
    const { displayStartTimeClock, rowIndex } = this.props;

    CuesheetCellActions.saveItemTimeField(
      rowIndex,
      'displayStartTimeClock',
      !displayStartTimeClock,
    );
  },

  _select() {
    const { rowIndex } = this.props;
    CuesheetCellActions.selectTimeCell(
      rowIndex,
      EditableCellTypes.ItemStartTime,
    );
  },

  _handleTab() {
    CuesheetCursorActions.moveCursorRight();
  },

  _handleOverride() {
    const { rowIndex } = this.props;

    CuesheetCellActions.saveItemTimeFields(rowIndex, {
      startOn: 0,
      startOnInReverse: false,
    });

    PopoverActions.hide(UIRegions.CuesheetStartTimeArrows, true);
  },
});
